import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const BinocularsIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="binoculars" ref={ref} {...props}>
      <path d="M21.17,14.17h0l0-.07L16.72,5l-.11-.22v0a.57.57,0,0,0-.12-.18,2.26,2.26,0,0,0-1.91-1,2.31,2.31,0,0,0-2.31,2.17.88.88,0,0,0,0,.23V6l0,.1s0,.07,0,.1a.13.13,0,0,0,0,.06h-.6a.86.86,0,0,0,0-.16.53.53,0,0,0,0-.12.57.57,0,0,0,0-.13.66.66,0,0,0,0-.14A2.32,2.32,0,0,0,9.43,3.54a2.29,2.29,0,0,0-2,1.13.2.2,0,0,0,0,.08l-.16.33-4.36,9,0,.07a4,4,0,0,0-.6,2.15,4.18,4.18,0,0,0,8.34.42h0l.11-1.05h2.54l.11,1.05a.43.43,0,0,1,0,.11.6.6,0,0,0,.06.19,4.18,4.18,0,0,0,8.29-.72A4,4,0,0,0,21.17,14.17ZM9.09,16.56a2.68,2.68,0,0,1-5.34-.27,2.65,2.65,0,0,1,.39-1.4l0-.05,0-.05a2.69,2.69,0,0,1,4.91,1.5A2.28,2.28,0,0,1,9.09,16.56Zm1.8-2.4.16-1.55H13l.16,1.55ZM17.57,19a2.69,2.69,0,0,1-2.66-2.4,2.64,2.64,0,0,1,0-.28A2.68,2.68,0,1,1,17.57,19ZM11.71,6.11a.53.53,0,0,0,0-.12l0,.28h0A.86.86,0,0,0,11.71,6.11Zm0-.25V6A.57.57,0,0,0,11.75,5.86Zm.54.41V6.21a.13.13,0,0,0,0,.06Zm0-.16s0,.07,0,.1l0-.2Z" />
    </Icon>
  ),
) as IconWithRender;

BinocularsIcon.displayName = 'BinocularsIcon';
BinocularsIcon.renderIcon = (props) => <BinocularsIcon {...props} />;
export default BinocularsIcon;
